import { z } from 'zod';

/**
 * The shared `start_words` / `start_time_ms` parameters for tools that time when an asset appears
 * (set_text, set_group_asset, set_icon). Both optional: omitting them leaves the asset appearing
 * with its scene. The parameter descriptions are deliberately terse: the rules for when and
 * how to time live in the how-to skills (see assetTimingGuidance.ts), not in tool text.
 */
export const ASSET_TIMING_SCHEMA_SHAPE = {
    start_words: z
        .array(z.string())
        .optional()
        .describe('Transcript tokens the asset appears on (voice-driven scenes).'),
    start_time_ms: z
        .number()
        .min(0)
        .optional()
        .describe('Milliseconds into the scene the asset appears (text-on-media scenes).'),
};
